<div class="cookie-overlay" *ngIf="isOpen">
  <div class="cookie-modal">

    <button class="close-btn" (click)="closeModal()">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="cookie-header">
      <h2>Cookie Preferences</h2>
      
      <p>
        This website uses necessary cookies to make it work. We also like to set optional "performance" cookies 
        to gather anonymous website visitation data and "marketing" cookies to help us understand which 
        content visitors value most. By enabling these cookies, you can help us provide a better website for all 
        users. For more information, view our <a href="/cookie-notice" class="policy-link">cookie notice</a>.
      </p>

      <button class="btn-accept-all-primary" (click)="acceptAll()">
        Accept All Cookies
      </button>
    </div>

    <div class="cookie-management-section">
      <h3>Manage Cookies</h3>

      <div class="cookie-table">
        
        <div class="cookie-row">
          <div class="cookie-row-header">
            <span class="expand-icon">+</span>
            <span class="cookie-name">Strictly Necessary Cookies</span>
          </div>
          <span class="status-always-active">Always Active</span>
        </div>

        <div class="cookie-row">
          <div class="cookie-row-header">
            <span class="expand-icon">+</span>
            <span class="cookie-name">Performance Cookies</span>
          </div>
          <label class="switch">
            <input 
              type="checkbox" 
              [(ngModel)]="preferences.analytics"
            >
            <span class="slider"></span>
          </label>
        </div>

        <div class="cookie-row">
          <div class="cookie-row-header">
            <span class="expand-icon">+</span>
            <span class="cookie-name">Marketing Cookies</span>
          </div>
          <label class="switch">
            <input 
              type="checkbox" 
              [(ngModel)]="preferences.marketing"
            >
            <span class="slider"></span>
          </label>
        </div>

      </div>
    </div>

    <div class="cookie-footer">
      
      <button class="btn-reject" (click)="rejectAll()">
        Reject All
      </button>
      
      <button class="btn-confirm" (click)="savePreferences()">
        Confirm My Choice
      </button>

    </div>

  </div>
</div>